import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchWorkdaysNCNP, filterAction, resetFilterAction } from '../actions/index';
import HoursOfServiceModal from './hours-of-service-modal';
import NonCertifiedPre16EmployeesWorkday from './non-certified-pre16-employees-workday';
import ActivityModalNCNP from './activity-modal-ncnp';
import CommentsModal from './comments-modal';
import AdminCommonSection from '../components/adminLayout';
import {Filters, Pagination, constants, KeolisSpinner, moment} from './common/commonExport';
import PDFPrinting from './PDFPrinting';
import NoRecords from '../components/NoRecords';

class NonCertifiedPre16EmployeesWorkdays extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numberOfPages: 0,
            pageNum: 1,
            certifyValue : 'Non-Certified',
            title : 'Non Certified Greater Than 16 days',
            filterState:{} 
        }
        localStorage.setItem('Pre16', 'True');
    }
    
    // get data for component
    getData(pageNum, filterObj){ // fetching data
        
        if(filterObj){
            filterObj = filterObj;
        } else {
            filterObj = this.state.filterState;
        }
        let self = this,
            authDetails = this.props.authDetails,
            role = authDetails.role;
            pageNum = filterObj.byPagination ? (pageNum) : (filterObj.byFilter ? 1 : pageNum);
        if(role == constants.roles.ADMIN_ROLE){
            let fetchObj = {
                url:constants.actionUrls.ADMIN_NCNP_URL,
                role: role,
                certifyStatus: this.state.certifyValue == 'Non-Certified' ? constants.UNCERTIFIED : constants.CERTIFIED,
                pageNum:pageNum,
                filterObj:filterObj
            }
            this.props.fetchWorkdaysNCNP(fetchObj, function(response){
                self.setState({
                    numberOfPages: response.totalPages,
                    pageNum: pageNum
                })
            });
           
            localStorage.setItem('route', this.state.certifyValue == 'Non-Certified' ? constants.UNCERTIFIED : constants.CERTIFIED);
        }
    };
    // resetting the filter component
    resetFilter(filterObj){
        let self = this;  
        filterObj["outlaw"] = false; 
        this.props.resetFilter(filterObj, function(response){
            self.setState({
                filterState:response
            });
        });
    }
    //called before the component renders
    componentWillMount() {
        let filterObj = this.props.filterState.defaultState ? this.props.filterState.defaultState:
                        this.props.filterState;
        this.resetFilter(filterObj); // before fetching data we have to reset filter
    }
    //called after the component renders
    componentDidMount(){
        let pageNum = this.state.pageNum;
        this.getData(pageNum);
    }    

    // show different modal as per needed
    renderModal() {
        let showModal = this.props.showModal, modalName = this.props.modalName;
        if(showModal){
            if (modalName == constants.hosModals.Certified_Modal) {
                return (
                    <HoursOfServiceModal workday={this.props.workday} />
                )
            } else if (modalName == constants.hosModals.Certify_Modal) {
                return (
                    <ActivityModalNCNP />
                )
            } 
        }

    }

    // rendering pagination component
    renderPagination() {
        let { pageNum, numberOfPages} = this.state,
            workdays = this.props.workdays, showPagination=false;
        if(workdays && workdays.length > 0 && numberOfPages > 1){
            showPagination = true;
        }
        return (<Pagination ShowPagination={showPagination} currentPage={pageNum}
            pageSize={numberOfPages} GetData={(pageNum, filterObj) => this.getData(pageNum, filterObj)} />)
    }

    checkTimeElapsed(d){
        let valid = false;
        if((d.days() > 0) && (d.hours() >= 0) && (d.minutes() >= 0)){
            valid = true;
        }else if ((d.days() == 0) && (d.hours() > 0) && (d.minutes() > 0)){
            valid = true;
        }else if ((d.days() == 0) && (d.hours() == 0) && (d.minutes() > 0)){
            valid = true;
        }else{
            valid = false;
        }
        return valid;
    }

    // render workdays component
    renderWorkdays() {
        let wdy_date, then, role = this.props.authDetails.role, workdays = this.props.workdays;
        if (this.props.isLoading) {
            return(
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        }
        else if (workdays && workdays.length > 0) {
                var timeElapsed,
                    now = moment(new Date(), "MM/DD/YYYY HH:mm").format('MM/DD/YY HH:mm');
            for (var i = 0; i < workdays.length; i++) {
                if(workdays[i].wdy_time_end){
                    var workdayTime = workdays[i].wdy_time_end.split(":");
                    if (workdayTime[0] > 23) {
                        wdy_date = moment(workdays[i].wdy_date, "MM/DD/YYYY").add(1, 'days').format("MM/DD/YYYY")
                        then = wdy_date + ' ' + Math.abs(24 - workdayTime[0]) + ':' + workdayTime[1]
                    } else {
                        wdy_date = workdays[i].wdy_date
                        then = wdy_date + ' ' + workdays[i].wdy_time_end
                    }
                    var timeDiff = moment(now, "MM/DD/YYYY HH:mm").diff(moment(then, "MM/DD/YYYY HH:mm")),
                        d = moment.duration(timeDiff),
                        showTimeElapsed = this.checkTimeElapsed(d);
                      if (workdays[i].wdy_time_end == 'NULL' || !showTimeElapsed){
                         workdays[i]['timeElapsed'] = '-'
                     }else{
                        workdays[i]['timeElapsed'] =
                            (d.days() == 0 ? '' : (d.days() + 'd'))
                            + (d.days() ? (d.hours() == 0 ? '0h' : d.hours() < 0 ? (d.hours() * -1 + 'h') : d.hours() + 'h') : d.hours() == 0 ? '' : d.hours() + 'h')
                            + ((d.hours() || d.days()) ? d.minutes() >= 0 ? d.minutes() : (d.minutes() * -1) : d.minutes() + 'm')
                     }
                } else {
                    workdays[i]['timeElapsed'] = '-';       
                }
            }
            return (workdays.length == 0 ?
                    <tr>
                        <td colSpan="100%">
                            No records available...
                        </td>
                    </tr> :
                        workdays.map(function (workday, index) {
                            return (
                                <NonCertifiedPre16EmployeesWorkday workday={workday} key={index} role = {role} />
                            );
                    })
            )
        } else {
            return (
                <NoRecords />
            )
        }
    }

    // filter in action
    getFilteredData(e, data){
        let pageNum = this.state.pageNum, filterObj = data;
        if(e){
            e.preventDefault();
        }        
        this.props.submitFilter(data);
        this.getData(pageNum, filterObj);
    }
    handleCertifyChange(value) {
     
        this.setState({ certifyValue : value,  title : value == 'Non-Certified' ? 'Non Certified Greater Than 16 days' : 'Certified Greater Than 16 days'}, () => {
            this.getData(this.state.pageNum);
          });
        
        //alert(this.state.certifyValue)//this.getData(this.state.pageNum);
    };
    
    render() {
        var route = localStorage.getItem('route') ? localStorage.getItem('route') : '',
            compTitle = constants.getComponentTitle(route);
        return (
            <AdminCommonSection compTitle={this.state.title} admin={true}
                tblBody={
                    <div>
                    <div className="row CertifyCombo">
                        <select className="form-control" name="CertifyType" value={this.state.jobType} onChange={(e) => this.handleCertifyChange(e.target.value)} >
                            <option value="Non-Certified" selected>Non Certified</option>
                            <option value="Certified">Certified</option>
                        </select><br/>
                    </div>
                    <Filters getData = {(e, data) => this.getFilteredData(e, data)}/>
                    <PDFPrinting Page="Projects" compTitle = {compTitle} details="Pre16" pageNo = {this.state.pageNum}/>
                    <div id="tblMainActivities">
                        <table className="table table-striped table-bordered_header table-condensed">
                            <thead className="thead-default">
                                <tr>
                                    <th>Division</th>
                                    <th className="text-center">Employee ID</th>
                                    <th className="text-center">Job</th>                                    
                                    <th className="text-center">First Name</th>
                                    <th className="text-center">Last Name</th>
                                    <th className="text-center">Service Date</th>
                                    <th className="text-center">Phone</th>
                                    <th className="text-center">HOS</th>
                                    <th className="text-center">TOS</th>
                                    <th className="text-center" title="Time between sign off and current time">Time Elapsed</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                            { 
                                this.renderWorkdays()
                            }
                        </tbody>
                        </table>
                        {
                            this.renderModal()
                        }
                        </div>
                        { 
                            this.renderPagination()
                        }
                        </div>
                }
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        workdays: state.workdays.workdays,
        hasErrored: state.workdays.itemsHasErrored,
        isLoading: state.workdays.isLoading,
        showModal: state.modals.showModal,
        modalName: state.modals.modalName,
        workday: state.workday.workday,
        authDetails:state.authState,
        filterState:state.filter
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            fetchWorkdaysNCNP: fetchWorkdaysNCNP, 
            submitFilter: filterAction,
            resetFilter:resetFilterAction 
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(NonCertifiedPre16EmployeesWorkdays);
